import type { OperatingSystem } from '@/types/operating-system'

export function isAndroid() {
  return /android/i.test(navigator.userAgent)
}

export function isIos() {
  return (
    /ipad|iphone|ipod/i.test(navigator.userAgent) ||
    (/mac/i.test(navigator.userAgent) && navigator.maxTouchPoints > 1)
  )
}

export function getOperatingSystem(): OperatingSystem {
  if (isAndroid()) return 'android'
  if (isIos()) return 'ios'

  return 'unknown'
}
